




















import { Component, Vue, Watch } from 'vue-property-decorator';
import TimetableEditor from '@/components/Timetable/components/TimetableEditor.vue';
import TimetableInfoDialog from '@/components/Timetable/components/TimetableInfoDialog.vue';
import BookingEditor from '@/components/Booking/components/BookingEditor.vue';
import BookingInfoDialog from '@/components/Booking/components/BookingInfoDialog.vue';
import { Timetable } from '@/components/Timetable/models/Timetable';
import { PassengerDialog } from '@/components/Passenger/components/PassengerDialog.vue';
import PassengerEditor from '@/components/Passenger/components/PassengerEditor.vue';
import Booking from '../components/Booking/models/Booking';
import { RolePermission } from '../models/Role';
import Destination from '../components/Passenger/models/Destination';

@Component({
  components: {
    TimetableEditor,
    TimetableInfoDialog,
    BookingEditor,
    BookingInfoDialog,
    PassengerDialog,
    PassengerEditor,
  },
  beforeRouteEnter(to, from, next) {
    // Update destination Timetable data in store each time the page is opened
    const destinationId = parseInt(to.params.destinationId, 10);
    next((vm) => (vm as TimetablePage).updateTimetables(destinationId));
  },
})
export class TimetablePage extends Vue {

  get me() {
    return this.$store.state.user.me;
  }

  get userCanViewBookings(): boolean {
    return this.me
      ? this.me.hasPermissions(this.routeDestinationId, [
          RolePermission.ReadBookings,
        ])
      : false;
  }

  get userCanViewTimeTables(): boolean {
    return this.me
      ? this.me.hasPermissions(this.routeDestinationId, [
          RolePermission.ReadTimetables,
        ])
      : false;
  }

  get selectedBookingRouteTabId(): number {
    return this.$store.state.route.name.includes('Booking') ? 0 : 1;
  }

  set selectedBookingRouteTabId(val: number) {
    // no-op
  }

  get storeTimetables(): Timetable[] {
    return this.$store.state.timetable.timetables;
  }

  get destinationTimetables(): Timetable[] {
    return this.storeTimetables.filter(t => t.destinationId === this.routeDestinationId);
  }

  get routeDestinationId(): number {
    return parseInt(this.$store.state.route.params.destinationId, 10);
  }

  get destination(): Destination {
    return this.$store.state.destination.destinations.find(d => d.id === this.routeDestinationId);
  }

  get storeBookings(): Booking[] {
    return this.$store.state.booking.bookings;
  }

  get destinationBookings(): Booking[] {
    return this.storeBookings.filter(t => t.destinationId === this.routeDestinationId);
  }

  onSingleBookingTabClick() {
    this.$router.push({
      name: 'BookingListWithState',
      params: {
        destinationId: this.routeDestinationId.toString(),
        state: 'open',
      },
    });
  }

  onRecurringBookingTabClick() {
    this.$router.push({
      name: 'TimetableListWithState',
      params: {
        destinationId: this.routeDestinationId.toString(),
        state: 'new',
      },
    });
  }

  // This refresh method is called whenever user navigates 
  // to the timetable root page (router beforeEnter)
  updateTimetables(destinationId: number) {
    if (this.userCanViewBookings) {
      this.$store.dispatch('booking/getDestinationBookings', {
        params: {
          destinationId,
        },
      });
    }

    if (this.userCanViewTimeTables) {
      this.$store.dispatch('timetable/getDestinationTimetables', {
        params: {
          destinationId,
        },
      });
      this.$store.dispatch('ride/getDestinationRides', {
        params: {
          destinationId,
        },
      });
    }
    this.$store.dispatch('destination/getTransportPermissions', {
      params: {
        destinationId,
      },
    });
  }
}

export default TimetablePage;
